import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">话题标签</h2>
          <p className="text-sm text-foreground-600 mt-3">全网热议话题实时热度排行，看看大家都在讨论什么</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {topicItems.map((item) => (
              <a
                key={item.rank}
                href="#cards"
                className="group inline-flex items-center gap-2 px-5 py-3 rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{
                  backgroundColor:
                    item.rank <= 3
                      ? 'oklch(var(--accent-100) / 0.3)'
                      : item.rank <= 6
                        ? 'oklch(var(--primary-100) / 0.3)'
                        : 'oklch(var(--secondary-100) / 0.3)',
                  borderColor:
                    item.rank <= 3
                      ? 'oklch(var(--accent-300) / 0.5)'
                      : item.rank <= 6
                        ? 'oklch(var(--primary-300) / 0.5)'
                        : 'oklch(var(--secondary-300) / 0.5)',
                }}
              >
                <span
                  className={`text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center ${
                    item.rank <= 3
                      ? 'bg-accent-500 text-background-50'
                      : item.rank <= 6
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-secondary-500 text-background-50'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.name}
                </span>
                <span className="text-xs text-foreground-500">{item.heat}</span>
                <i
                  className={`text-xs ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-accent-500'
                      : item.trend === 'down'
                        ? 'ri-arrow-down-line text-foreground-400'
                        : 'ri-add-line text-primary-500'
                  }`}
                ></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}